import { isMagasinOpened } from "@/utils/magasin";
import ShopPageCodes from "@/utils/fiche-magasin-codes";
import { pushProps, usePush } from "@/components/pages/mixins/push-mixin";

export const templatePageMagasinProps = () => ({
  magasin: {
    type: Object,
    required: false,
    default: null
  },
  isPro: {
    type: Boolean,
    required: false,
    default: false
  },
  hasBlog: {
    type: Boolean,
    required: false,
    default: true
  },
  attachedShopId: {
    type: Number,
    required: false,
    default: 0
  },
  context: {
    type: String,
    required: false,
    default: null
  },
  article: {
    type: Object,
    required: false,
    default: () => { }
  },
  isNational: {
    type: Boolean,
    required: false,
    default: false
  },
  ...pushProps()
})

export const templatePageMagasinEmits = () => ([
  "changeShop"
])

export const useTemplatePageMagasin = (props, context) => {
  const { getPushData } = usePush(props.pushZones);
  const selectedShopId = ref(null)
  const maxServices = ref(2)

  const itineraire = computed(() => {
    const itineraireUrl = 'https://www.google.fr/maps/dir//'
    return props.magasin.attributes.latitude && props.magasin.attributes.longitude ? itineraireUrl + props.magasin.attributes.latitude + ',' + props.magasin.attributes.longitude : ''
  })
  const exceptionalOpening = computed(() => {
    const exceptionalDays = props.magasin.attributes.horaires_exceptionnels_table ? props.magasin.attributes.horaires_exceptionnels_table.find(e => e.type === "Magasin") : []
    return exceptionalDays && exceptionalDays.horaires.filter(e => e.type === "Ouverture")
  })
  const exceptionalClosure = computed(() => {
    const exceptionalDays = props.magasin.attributes.horaires_exceptionnels_table ? props.magasin.attributes.horaires_exceptionnels_table.find(e => e.type === "Magasin") : []
    return exceptionalDays && exceptionalDays.horaires.filter(e => e.type === "Fermeture")
  })
  const shopTimetable = computed(() => {
    const shopTimetable = props.magasin.attributes.horaires_table && props.magasin.attributes.horaires_table.find(e => e.type === "Magasin")
    return shopTimetable
  })
  const positions = computed(() => {
    const positions = [
      {
        lat: props.magasin.attributes.latitude ? props.magasin.attributes.latitude : 0,
        lng: props.magasin.attributes.longitude ? props.magasin.attributes.longitude : 0
      }]
    return positions;
  })
  const hasMagasin = computed(() => {
    if (parseInt(props.magasin.id) === props.attachedShopId || selectedShopId.value) {
      return false
    } else {
      return true
    }
  })
  const horairesMagasin = computed(() => {
    return props.magasin.attributes.horaires;
  })
  const isOpen = computed(() => {
    return isMagasinOpened(props.magasin);
  })

  const changeShop = (storeId) => {
    context.emit("changeShop", storeId);
    selectedShopId.value = storeId
  }
  const displayAllServices = () => {
    if (maxServices.value === 2) {
      maxServices.value = props.magasin.attributes.services.length
    } else {
      maxServices.value = 2
    }
  }

  return {
    ShopPageCodes,
    selectedShopId,
    maxServices,
    itineraire,
    exceptionalOpening,
    exceptionalClosure,
    shopTimetable,
    positions,
    hasMagasin,
    horairesMagasin,
    isOpen,
    changeShop,
    displayAllServices,
    getPushData
  }
}